module.exports = __webpack_public_path__ + "static/media/cases_item_1.6edce1b9.png";